import * as React from 'react';
import { ClassNames } from '@rocketmakers/armstrong-edge';
import cross from '../assets/icons/cross.svg';
import './companyPanel.scss';
import { ILocation, seedRangeOutput } from '../typings/data';
import { StringHelpers } from '../helpers/stringHelpers';
import { AppContext } from '../context/appProvider';
import { orderBy, slice } from 'lodash';

interface IProps {
  location: ILocation;
  isCardsPage?: boolean;
  onCompanyClick?: (location: ILocation) => void;
}

const CompanyPanel: React.FC<IProps> = ({ location, isCardsPage, onCompanyClick }) => {
  const [panelOpen, setPanelOpen] = React.useState(true);
  const [selectedLocation, setSelectedLocation] = React.useState<ILocation>();
  const { allLocations } = React.useContext(AppContext);
  const upperCaseName = StringHelpers.slugToSentence(StringHelpers.toUpper(location.name));
  const upperCaseCategory = StringHelpers.slugToSentence(StringHelpers.toUpper(location.category));
  const titleCaseCategory = StringHelpers.slugToSentence(StringHelpers.toTitleCase(location.category));
  const upperCaseInvestment = (seedLevel) => StringHelpers.slugToSentence(StringHelpers.toUpper(seedLevel));
  const lowerCaseInvestment = (seedLevel) => StringHelpers.slugToSentence(StringHelpers.toLower(seedLevel));

  const similarLocationsSliced = React.useMemo(() => {
    return allLocations
      .filter((l) => l.category === location.category)
      .filter((l) => l.name !== location.name)
      .sort(() => Math.random() - 0.5)
      .slice(0, 2);
  }, [allLocations, location]);

  return (
    <div
      className={
        !panelOpen
          ? ClassNames.concat('panel company-content', isCardsPage && 'isCardsPage', 'closed')
          : ClassNames.concat('panel company-content', isCardsPage && 'isCardsPage', location.category, 'open')
      }
    >
      {!isCardsPage && (
        <div className="panel-tab-container">
          <div className="panel-tab-company">
            <p>
              <img alt={location.category} src={`/icons/${location.category}-full.svg`} />
              {upperCaseCategory}
            </p>
          </div>
        </div>
      )}
      <>
        <div className="panel-header">
          <div className="panel-header-company-info">
            <h2>{upperCaseName}</h2>
            <div className="location">{`${location.postcode}`}</div>
          </div>
          {!isCardsPage && (
            <div className="cross-mark" onClick={() => setPanelOpen(false)}>
              <img src={cross} />
            </div>
          )}
          <div className={!location.investment ? ClassNames.concat('card-footer', 'funds-unknown') : 'card-footer'}>
            {location.investment && (
              <img
                className="finance-icon"
                alt={location.investment + ' icon'}
                src={`/icons/${lowerCaseInvestment(location.investment)}.svg`}
              />
            )}
            {upperCaseInvestment(location.investment)}
            <span className="seed-range">{seedRangeOutput(location.investment)}</span>
          </div>
        </div>
        <div className="panel-content">
          {location.description && <div className="description">{location.description}</div>}
          <div className="btn-container">
            {location.webUrl && (
              <a className="btn company-link" target="_blank" href={location.webUrl}>
                {`${upperCaseName} WEBSITE`}
              </a>
            )}
          </div>
          {!isCardsPage && onCompanyClick && (
            <>
              <div className="more-locations-header">
                More <b>{titleCaseCategory}</b> Companies
              </div>
              <div className="more-locations-box">
                {similarLocationsSliced.map((location) => (
                  <div className="more-location-card" onClick={() => onCompanyClick(location)}>
                    <div className="more-location-card-text">{location.name}</div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </>
    </div>
  );
};

export default CompanyPanel;
